var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.311,
    viewBox: "0 0 16 13.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M53.977,46.219a6.759,6.759,0,0,1-1.371,1.506.586.586,0,0,0-.211.457v.053a9.6,9.6,0,0,1-.619,3.34,9.783,9.783,0,0,1-1.822,3.054,9,9,0,0,1-3.949,2.61,9.878,9.878,0,0,1-3.1.482,9.477,9.477,0,0,1-4.759-1.282.274.274,0,0,1-.132-.3.263.263,0,0,1,.257-.2h.4a6.369,6.369,0,0,0,3.568-1.083A3.458,3.458,0,0,1,39.5,52.5a.181.181,0,0,1,.211-.234,3.175,3.175,0,0,0,.581.055h.074a3.46,3.46,0,0,1-2.016-3.182.181.181,0,0,1,.267-.158,3.042,3.042,0,0,0,.788.305,3.458,3.458,0,0,1-.558-4.2.181.181,0,0,1,.3-.025,9.042,9.042,0,0,0,6.215,3.324h.017a.131.131,0,0,0,.126-.141,3.656,3.656,0,0,1,.08-1.264,3.351,3.351,0,0,1,2.254-2.409,3.7,3.7,0,0,1,1.093-.168,3.446,3.446,0,0,1,2.283.861.446.446,0,0,0,.3.114.453.453,0,0,0,.105-.015,6.319,6.319,0,0,0,1.685-.7.179.179,0,0,1,.263.211,3.418,3.418,0,0,1-.908,1.447,6.361,6.361,0,0,0,1.1-.373.181.181,0,0,1,.221.261Z",
    transform: "translate(-38.002 -44.41)",
    fill: "#00a6de"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.9dee1dd4f6c82cc8ddd08fc1a1123d27.svg";
export { ForwardRef as ReactComponent };